import React from 'react'
import { enqueueSnackbar, closeSnackbar } from 'notistack'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'

const autoHideDuration = 3000

export const ToastMessages = {
  paymentMethodCannotBeChanged: text => {
    enqueueSnackbar(
      text ? text : `A forma de pagamento deste reagendamento não pode ser alterada.`,
      {
        variant: 'error',
        autoHideDuration: autoHideDuration,
      },
    )
  },

  cannotOpenDetailsWhileRescheduling: () => {
    enqueueSnackbar('Näo é possivel ver outro agendamento enquanto estiver reagendando', {
      variant: 'error',
      autoHideDuration: autoHideDuration,
    })
  },
  mismatchCourtPaymentMethodOnRescheduling: () => {
    enqueueSnackbar('Forma de pagamento incompatível com o reagendamento', {
      variant: 'warning',
      autoHideDuration: autoHideDuration,
    })
  },
  userRescheduleLimit: () =>
    enqueueSnackbar(
      'Você atingiu o limite de 2 reagendamentos. Se precisar mudar seu horário, entre em contato com o centro esportivo pelo chat.',
      {
        variant: 'warning',
        autoHideDuration: autoHideDuration,
      },
    ),
  rescheduleTimeExpired: () =>
    enqueueSnackbar('Não é possível reagendar, o prazo de antecedência já esgotou.', {
      variant: 'warning',
      autoHideDuration: autoHideDuration,
    }),
  unavailableCourtDate: () =>
    enqueueSnackbar('Data indisponível para o agendamento nesta quadra.', {
      variant: 'warning',
      autoHideDuration: autoHideDuration,
    }),

  // Generic messages
  success: message => {
    enqueueSnackbar(message, {
      variant: 'success',
      autoHideDuration: autoHideDuration,
    })
  },

  error: message => {
    enqueueSnackbar(message, {
      variant: 'error',
      autoHideDuration: autoHideDuration,
    })
  },

  warning: message => {
    enqueueSnackbar(message, {
      variant: 'warning',
      autoHideDuration: autoHideDuration,
    })
  },

  info: message => {
    enqueueSnackbar(message, {
      variant: 'info',
      autoHideDuration: autoHideDuration,
    })
  },

  persistentWarning: message => {
    enqueueSnackbar(message, {
      variant: 'warning',
      persist: true, // mantém até fechar manualmente
      action: key => (
        <IconButton
          aria-label='fechar'
          color='inherit'
          size='small'
          onClick={() => closeSnackbar(key)}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
      ),
    })
  },
}
